<div class="create_popup">
    <div class="modal-body">
  
      <!-- Header -->
      <!-- <div class="order-header">
        <div>
          <h4 class="title">Create New Order</h4>
          <p class="subtitle">Fill in the details below</p>
        </div>
        <div class="header-actions">
          <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="onSubmit()">Create Order</button>
        </div>
      </div> -->
  
      <form [formGroup]="orderForm">
  
        <!-- Section 1: Customer & Schedule -->
        <div class="form-section">
          <div class="section-title">
            <span class="step-badge">1</span>
            <h5>Customer &amp; Schedule</h5>
          </div>
  
          <div class="section-body">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 mb-1 form-field">
                  <div class="col-md-12">
                      <label>Organization Type<span style="color:red">*</span>: </label>
                  </div>
                  <div class="col-md-12">
                    <ng-select
                        [multiple]="false"
                        formControlName="accountId"
                        appendTo="body"
                        [items]="accountList"
                        bindLabel="accountName"
                        bindValue="id"
                        [loading]="isLoadingAccounts"
                        (search)="onAccountSearch($event)"
                        (scrollToEnd)="loadMoreAccounts()">
                    </ng-select>
                  </div>
              </div>
              <div class="col-md-6 col-sm-6 mb-1 form-field">
                <label>Customer <span class="required">*</span></label>
                <ng-select
                  [items]="customers"
                  bindLabel="customerName"
                  bindValue="id"
                  appendTo="body"
                  placeholder="Select customer"
                  (change)="customerChange($event)"
                  formControlName="customer">
                </ng-select>
                <small class="error" *ngIf="isInvalid('customer')">
                  Customer is required
                </small>
              </div>
  
              <div class="col-md-6 col-sm-6 mb-1 form-field">
                <label>Assigned KAM</label>
                <ng-select
                  [items]="kamList"
                  bindLabel="name"
                  bindValue="id"
                  appendTo="body"
                  [readonly]="true"
                  placeholder="Select KAM"
                  formControlName="assignedKam">
                </ng-select>
              </div>

              <div class="col-md-6 col-sm-6 mb-1 form-field">
                <label>Assigned Procurement Exec.</label>
                <ng-select
                  [items]="procurementExecList"
                  bindLabel="name"
                  bindValue="id"
                  appendTo="body"
                  placeholder="Select procurement executive"
                  formControlName="assignedProcurementExec">
                </ng-select>
              </div>
  
              <div class="col-md-6 col-sm-6 mb-1 form-field">
                <label>Placement Date &amp; Time <span class="required">*</span></label>
                <p-calendar
                  formControlName="placementDateTime"
                  [showTime]="true"
                  [showSeconds]="false"
                  hourFormat="24"
                  dateFormat="dd-mm-yy"
                  [stepMinute]="5"
                  [minDate]="minPlacementDate"
                  [showIcon]="false"
                  inputStyleClass="form-control"
                  appendTo="body"
                  placeholder="Select date & time"
                ></p-calendar>
              
                <small class="error" *ngIf="isInvalid('placementDateTime') && orderForm.get('placementDateTime')?.hasError('required')">
                  Placement date &amp; time is required
                </small>
                <small class="error" *ngIf="isInvalid('placementDateTime') && orderForm.get('placementDateTime')?.hasError('minDateTime')">
                  Placement date &amp; time must be at least 1 hour from now
                </small>
              </div>

            </div>
  
            <!-- <div class="form-row"> -->
  
              <!-- <div class="form-field"></div> -->
            <!-- </div> -->
          </div>
        </div>
  
        <!-- Section 2: Order Type -->
        <div class="form-section">
          <div class="section-title">
            <span class="step-badge">2</span>
            <h5>Order Type <span class="required">*</span></h5>
          </div>
  
          <div class="section-body">
            <div class="order-type-options">
              <div
                class="order-type-card"
                *ngFor="let type of orderTypes"
                [class.selected]="orderForm.get('orderType')?.value === type.value"
                (click)="selectOrderType(type.value)">
                <div class="order-type-icon" [ngClass]="type.value.toLowerCase()">
                  <i [attr.data-feather]="type.icon"></i>
                </div>
                <div class="order-type-text">
                  <div class="order-type-label">{{ type.label }}</div>
                  <div class="order-type-desc">{{ type.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Section 3: Shipment Line Items (Spot Only) -->

        <div class="form-section" *ngIf="orderForm.get('orderType')?.value === 'Spot'">

            <div class="section-title">
            <div class="d-flex align-items-center gap-2">
                <span class="step-badge">3</span>
                <h5>Shipment Line Items</h5>
            </div>
            <!-- Removed + Add button -->
            </div>
        
            <div class="section-body" formArrayName="shipmentLineItems">
        
            <div class="line-item-card"
                *ngFor="let item of shipmentLineItems.controls; let i=index"
                [formGroupName]="i">
        
                <div class="line-item-header">
                <span>Line Item {{ i + 1 }}</span>
                <!-- Removed Remove link since only one item -->
                </div>
        
                <div class="form-row">
        
                  <div class="col-md-3 col-sm-3 form-field">
                    <label>From <span class="required">*</span></label>
                    <ng-select
                      [items]="locationList"
                      bindLabel="cityName"
                      bindValue="id"
                      appendTo="body"
                      placeholder="Select From Location"
                      formControlName="sourceId">
                    </ng-select>
                    <input
                      *ngIf="shipmentLineItems.at(i).get('sourceId')?.value == -1"
                      type="text"
                      class="form-control mt-2"
                      placeholder="Type Location"
                      formControlName="originAddress">
                    <small class="error" *ngIf="isGroupInvalid(shipmentLineItems.at(i), 'sourceId')">
                      Source location is required
                    </small>
                </div>
                
                <div class="col-md-3 col-sm-3 form-field">
                    <label>To <span class="required">*</span></label>
                    <ng-select
                      [items]="locationList"
                      bindLabel="cityName"
                      bindValue="id"
                      appendTo="body"
                      placeholder="Select To Location"
                      formControlName="destinationId">
                    </ng-select>
                    <input
                      *ngIf="shipmentLineItems.at(i).get('destinationId')?.value == -1"
                      type="text"
                      class="form-control mt-2"
                      placeholder="Type Location"
                      formControlName="destinationAddress">
                    <small class="error" *ngIf="isGroupInvalid(shipmentLineItems.at(i), 'destinationId')">
                      Destination location is required
                    </small>
                </div>
                
                <div class="col-md-3 col-sm-3 form-field">
                    <label>Vehicle Type <span class="required">*</span></label>
                    <ng-select
                      [items]="vehicleTypeList"
                      bindLabel="vehicleType"
                      bindValue="id"
                      appendTo="body"
                      formControlName="vehicleType">
                    </ng-select>
                    <small class="error" *ngIf="isGroupInvalid(shipmentLineItems.at(i), 'vehicleType')">
                      Vehicle type is required
                    </small>
                </div>
        
                <!-- <div class="col-md-3 col-sm-3 form-field">
                    <label>Trucks</label>
                    <input type="number" class="form-control" readonly formControlName="trucks">
                </div> -->
        
                </div>
            </div>
        
            </div>
        </div>

        <!-- Section 3: Route Details -->

        <div
            class="form-section"
            *ngIf="orderForm.get('orderType')?.value === 'Contract'">
            <div class="section-title between">
            <div class="d-flex align-items-center gap-2">
                <span class="step-badge">3</span>
                <h5>Route Details</h5>
            </div>
            </div>
        
            <div class="section-body" formGroupName="routeDetails">
        
            <div
                class="line-item-card">
        
                <div class="form-row">
        
                <div class="col-md-3 col-sm-3 form-field">
                    <label>Route</label>
        
                    <ng-select
                    [items]="routes"
                    bindLabel="name"
                    bindValue="id"
                    appendTo="body"
                    placeholder="Select Route"
                    formControlName="routeId">
                    </ng-select>
                </div>
        
                <div class="col-md-3 col-sm-3 form-field">
                  <label>Vehicle Type <span class="required">*</span></label>
                  <ng-select
                    [items]="vehicleTypeList"
                    bindLabel="vehicleType"
                    bindValue="id"
                    [readonly]="true"
                    appendTo="body"
                    placeholder="Select Vehicle Type"
                    formControlName="vehicleType">
                  </ng-select>
                  <small class="error" *ngIf="isGroupInvalid(routeDetails, 'vehicleType')">
                    Vehicle type is required — select a route first
                  </small>
              </div>
        
                <!-- <div class="col-md-3 col-sm-3 form-field">
                    <label>Truck Count <span class="required">*</span></label>
        
                    <input
                    type="number"
                    class="form-control"
                    [readOnly]="true"
                    formControlName="noOfVehicle">
                </div> -->
        
                <div class="col-md-3 col-sm-3 form-field">
                    <label>Price</label>

                    <!-- Price is auto-filled from the selected route's agreed cost and
                         must not be hand-edited, so it's readonly once a route is chosen. -->
                    <input
                    type="number"
                    class="form-control"
                    formControlName="price"
                    readonly
                    title="Auto-filled from the selected route">
                </div>
        
                </div>
        
            </div>
        
            </div>
        </div>

        <!-- Section 4: Pickup & Drop Locations (Common to Spot & Contract) -->
        <!--
          Pickup & Drop are always added/removed together as a PAIR — one
          "Location" card = 1 pickup FormGroup (pickupLocations[i]) + 1 drop
          FormGroup (dropLocations[i]) at the same index. A single
          "+ Add Location" button pushes into both arrays; a single remove
          button removes both. Payload build (buildOrderPoints) is unchanged
          — it still reads pickupLocations / dropLocations independently.
        -->
        <div class="form-section">
          <div class="section-title between">
            <div class="d-flex align-items-center gap-2">
              <span class="step-badge">4</span>
              <h5>Pickup &amp; Drop Locations</h5>
            </div>
          </div>

          <div class="section-body">

            <div
              class="location-pair-block border rounded p-3 mb-3"
              *ngFor="let pickup of pickupLocations.controls; let i = index">

              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6 class="mb-0">Location {{ i + 1 }}</h6>
                <button
                  type="button"
                  class="btn btn-link text-danger"
                  *ngIf="pickupLocations.length > 1"
                  (click)="removeLocationRow(i)">
                  🗑
                </button>
              </div>

              <div class="row">

                <!-- Pickup -->
                <div class="col-md-6" [formGroup]="asFormGroup(pickupLocations.at(i))">
                  <div class="border rounded p-3">
                    <h6>Pickup Location</h6>

                    <div class="row">
                      <div class="col-md-5">
                        <input
                          class="form-control"
                          placeholder="Pincode"
                          formControlName="pincode">
                      </div>

                      <div class="col-md-7">
                        <ng-select
                          [items]="locationList"
                          bindLabel="cityName"
                          bindValue="id"
                          appendTo="body"
                          placeholder="Select Location"
                          formControlName="city">
                        </ng-select>

                        <input
                          *ngIf="pickupLocations.at(i).get('city')?.value == -1"
                          class="form-control mt-2"
                          placeholder="Type Location"
                          formControlName="otherCity">
                      </div>
                    </div>

                    <input
                      class="form-control mt-2"
                      placeholder="Full Address"
                      formControlName="address">
                  </div>
                </div>

                <!-- Drop -->
                <div class="col-md-6" [formGroup]="asFormGroup(dropLocations.at(i))">
                  <div class="border rounded p-3">
                    <h6>Drop Location</h6>

                    <div class="row">
                      <div class="col-md-5">
                        <input
                          class="form-control"
                          placeholder="Pincode"
                          formControlName="pincode">
                      </div>

                      <div class="col-md-7">
                        <ng-select
                          [items]="locationList"
                          bindLabel="cityName"
                          bindValue="id"
                          appendTo="body"
                          placeholder="Select Location"
                          formControlName="city">
                        </ng-select>

                        <input
                          *ngIf="dropLocations.at(i).get('city')?.value == -1"
                          class="form-control mt-2"
                          placeholder="Type Location"
                          formControlName="otherCity">
                      </div>
                    </div>

                    <input
                      class="form-control mt-2"
                      placeholder="Full Address"
                      formControlName="address">
                  </div>
                </div>

              </div>
            </div>

            <button
              type="button"
              class="btn btn-add mt-2"
              (click)="addLocationRow()">
              + Add Location
            </button>

          </div>
        </div>
  
        <!-- Section 5: Pricing (only for Spot orders) -->
        <div class="form-section" *ngIf="orderForm.get('orderType')?.value === 'Spot'">
          <div class="section-title">
            <span class="step-badge">5</span>
            <h5>Pricing &mdash; Spot</h5>
          </div>
  
          <div class="section-body">
            <label class="group-label">Customer Rate Type</label>
            <div class="rate-type-options">
              <div
                class="rate-type-card"
                *ngFor="let rt of customerRateTypes"
                [class.selected]="orderForm.get('customerRateType')?.value === rt.value"
                (click)="selectCustomerRateType(rt.value)">
                {{ rt.label }}
              </div>
            </div>
  
            <div class="customer-rate-box" *ngIf="orderForm.get('customerRateType')?.value === 'RATE_KNOWN'">
              <div class="box-title">Customer Rate (KAM)</div>
              <div class="form-row">
                <div class="form-field">
                  <label>Customer Rate (₹) <span class="required">*</span></label>
                  <input type="text" appIndianNumberFormat class="form-control" formControlName="customerRate" placeholder="" />
                  <small class="error" *ngIf="isInvalid('customerRate')">
                    Customer rate is required
                  </small>
                </div>
  
                <div class="form-field">
                  <label>Historical Rate (₹)</label>
                  <input type="text" appIndianNumberFormat class="form-control" [disabled]="true" style="background: #e5e5e5;" formControlName="historicalRate" placeholder="" readonly />
                </div>
              </div>
            </div>

            <ng-container *ngIf="orderForm.get('customerRateType')?.value === 'NULL_PRICE'">
                <div class="null-price-info">
                  <div class="info-icon">
                    🚫
                  </div>
              
                  <div class="info-content">
                    <div class="info-title">
                      No pricing required
                    </div>
              
                    <div class="info-text">
                      This order will proceed without a rate.
                      Pricing can be updated later before dispatch.
                    </div>
                  </div>
                </div>
              </ng-container>
          </div>
        </div>
  
        <div class="d-flex align-items-center justify-content-end">
          <button
            type="button"
            class="btn btn-primary mr-10"
            *ngIf="!isEdit || editData?.biddingEnable === 0"
            (click)="onSubmit('DRAFT')">
            Save Draft
          </button>
            <button type="button" class="btn btn-primary" (click)="onSubmit('')">{{isEdit ? 'Update' : 'Create'}} Order</button>
        </div>

      </form>
    </div>
  </div>